import { IMainHeader } from "@/domain/main-header/entity/MainHeader.interface";
import { MainHeaderApplicationDataProvider } from "@/domain/main-header/application/MainHeaderApplicationData.provider";
import { ScriptSelector } from "@/domain/main-header/entity/ScriptSelector.enum";
import { QuickSearch } from "@/domain/main-header/entity/QuickSearch.interface";

export class QuickSearchConfigurationProvider {
    public static provideTo(mainHeaderApplicationData: Partial<IMainHeader>): Partial<IMainHeader> {
        const quickSearchData = MainHeaderApplicationDataProvider.hasProvidedDataFor(ScriptSelector.QUICK_SEARCH) ?
            MainHeaderApplicationDataProvider.parseProvidedData<QuickSearch>(ScriptSelector.QUICK_SEARCH)
            : null;

        if (!quickSearchData) {
            return mainHeaderApplicationData;
        }

        mainHeaderApplicationData.quickSearch = quickSearchData;

        return mainHeaderApplicationData
    }
}